
<template>
  <div class="modal modal-blur fade" v-bind:id="dlgId" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{title}}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z"/><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
          </button>
        </div>
        <div class="modal-body">
          <input type="text" class="form-control" v-model="str" />
        </div>
        
        <div class="modal-body">
          <button class="btn btn-danger" data-dismiss="modal">Cancel</button>
          <button class="btn btn-primary" data-dismiss="modal" @click.prevent="onUpdate">Update</button>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
  import WebLLCRESTApi from "../api/api";
  export default {
    data() {
      return {
        str: ""
      };
    },
    
    props: {
      title: String,
      dlgId: String,
      defaultStr: String,
      refreshId: String
    },
    
    methods: {
      onUpdate() {
        this.$emit("updated", this.str);
      }
    },
    
    watch: {
      refreshId(to) {
        this.str = this.defaultStr;
      },
      
      defaultStr(to) {
        this.str = to;
      }
    }

  }
</script>



// WEBPACK FOOTER //
// src/components/EditStringDlg.vue